var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _vm.cities
          ? _c("div", [
              _c("table", { staticClass: "table table-hover table-sm" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm._l(
                      _vm.sortArray(_vm.stores, "title"),
                      function (store, index) {
                        return [
                          _c("tr", [
                            _c("td", [_vm._v(_vm._s(store.id))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(store.title))]),
                            _vm._v(" "),
                            _c("td", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.settings[store.id].transit.stickers
                                        .int_value,
                                    expression:
                                      "settings[store.id].transit.stickers.int_value",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.settings[store.id].transit.stickers
                                      .int_value
                                  )
                                    ? _vm._i(
                                        _vm.settings[store.id].transit.stickers
                                          .int_value,
                                        null
                                      ) > -1
                                    : _vm.settings[store.id].transit.stickers
                                        .int_value,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a =
                                        _vm.settings[store.id].transit.stickers
                                          .int_value,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.settings[store.id].transit
                                              .stickers,
                                            "int_value",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.settings[store.id].transit
                                              .stickers,
                                            "int_value",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.settings[store.id].transit.stickers,
                                        "int_value",
                                        $$c
                                      )
                                    }
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: store.city_id,
                                      expression: "store.city_id",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          store,
                                          "city_id",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      function ($event) {
                                        store.is_changed = true
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "0" } }, [
                                    _vm._v("Все другие города"),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.cities, function (city, id) {
                                    return _c(
                                      "option",
                                      { domProps: { value: id } },
                                      [_vm._v(_vm._s(city))]
                                    )
                                  }),
                                ],
                                2
                              ),
                            ]),
                          ]),
                        ]
                      }
                    ),
                  ],
                  2
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "text-right" },
      [
        _c(
          "vue-ladda",
          {
            attrs: {
              "button-class": "btn btn-success btn-sm",
              "data-style": "zoom-in",
              loading: _vm.btnLoading,
            },
            on: {
              click: function ($event) {
                return _vm.saveStoreData()
              },
            },
          },
          [_vm._v("Сохранить\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Редактирование направлений")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Склад")]),
        _vm._v(" "),
        _c("th", [_vm._v("Стикер")]),
        _vm._v(" "),
        _c("th", [_vm._v("Город")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }